"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Badge = void 0;
var react_1 = __importDefault(require("react"));
var prop_types_1 = __importDefault(require("prop-types"));
var Badge = function (_a) {
    var children = _a.children, type = _a.type;
    var className = 'storybook-texts-badge';
    if (type) {
        className += " storybook-texts-badge-" + type;
    }
    return react_1.default.createElement("span", { className: className }, children);
};
exports.Badge = Badge;
exports.Badge.propTypes = {
    /**
     * The HTML inside
     */
    children: prop_types_1.default.any,
    /**
     * The type of Badge
     */
    type: prop_types_1.default.oneOf(['primary', 'secondary', 'success', 'live', 'idle'])
};
exports.Badge.defaultProps = {};
